import React from 'react';
import styled, { useTheme } from 'styled-components';

// TO DO: Delete Components
// import ArrowDown from '@images/icons/MenuArrowDown.svg';
// import WhiteArrowDown from '@images/icons/MenuArrowDownWhite.svg';

const ArrowStyles = styled.svg`
	transition: transform 0.5s ease;
	transform: rotate(${({ rotating }) => (rotating ? 180 : 0)}deg);
`;

const Arrow = ({ color, rotating }) => (
	<ArrowStyles
		xmlns="http://www.w3.org/2000/svg"
		width="10"
		height="7"
		viewBox="0 0 10 7"
		fill="none"
		rotating={rotating}
	>
		<path d="M1 1L5 5L9 1" stroke={color} stroke-width="1.5" />
	</ArrowStyles>
);

export default ({ rotating, reverse }) => {
	const theme = useTheme();

	return (
		<Arrow
			rotating={rotating}
			color={reverse ? theme.colors.white.main : theme.colors.black.main}
		/>
	);
};
